<template>
    <div>
      <el-dialog title="Ачааны дэлгэрэнгүй" :visible.sync="this.$root.progressDetailDialog" :before-close="handleClose" width="350px" center>
        <div>
            <el-tag v-if="trackCodeDetail.track_code">{{ trackCodeDetail.track_code }}</el-tag>
        </div>
        <div class="m-t-10">
            <a v-if="trackCodeDetail.phone_number" :href="'tel:' + trackCodeDetail.phone_number" class="blue_text">
                <i class="el-icon-phone-outline"></i>
                {{ trackCodeDetail.phone_number }}
            </a>
        </div>
        <div>
            <span v-if="trackCodeDetail.description">Тайлбар: {{ trackCodeDetail.description }}</span>
        </div>
        <div>
            <span v-if="trackCodeDetail.price">Ачааны төлбөр: {{ trackCodeDetail.price | formatCurrency() }}</span>
        </div>
        <div>
            <span v-if="trackCodeDetail.price">Хадгалалтын төлбөр: {{ trackCodeDetail.save_price | formatCurrency() }}</span>
        </div>
        <div>
            <span>Төлөх төлбөр: {{ trackCodeDetail.price + trackCodeDetail.save_price | formatCurrency() }}</span>
        </div>
        <div>
            <span v-if="trackCodeDetail.is_paid && trackCodeDetail.is_paid === true">Төлбөр төлсөн эсэх: Төлсөн</span>
            <span v-if="trackCodeDetail.is_paid && trackCodeDetail.is_paid === false">Төлбөр төлсөн эсэх: Төлөөгүй</span>
        </div>
        <div>
            <span v-if="trackCodeDetail.price_to_pay">Төлсөн төлбөр: {{ trackCodeDetail.price_to_pay | formatCurrency() }}</span>
        </div>
        <div>
            <span v-if="trackCodeDetail.paid_date">Төлбөр төлсөн огноо: {{ trackCodeDetail.paid_date.split('T')[0] }}</span>
        </div>
        <div>
            <span v-if="trackCodeDetail.paid_type && trackCodeDetail.paid_type === 'cash'">Төлбөрийн хэлбэр: Бэлэн төлөлт</span>
            <span v-if="trackCodeDetail.paid_type && trackCodeDetail.paid_type === 'transaction'">Төлбөрийн хэлбэр: Шилжүүлэг</span>
            <span v-if="trackCodeDetail.paid_type && trackCodeDetail.paid_type === 'card'">Төлбөрийн хэлбэр: Карт</span>
            <span v-if="trackCodeDetail.paid_type && trackCodeDetail.paid_type === 'notpay'">Төлбөрийн хэлбэр: Төлбөр төлөхгүй</span>
            <span v-if="trackCodeDetail.paid_type && trackCodeDetail.paid_type === 'cupon'">Төлбөрийн хэлбэр: Купон</span>
        </div>
        <div>
            <span v-if="trackCodeDetail.ConfigType && trackCodeDetail.ConfigType.name">Ачааны хэмжээ: {{ trackCodeDetail.ConfigType.name }}</span>
        </div>
        <div>
            <span v-if="trackCodeDetail.jin">Ачааны жин: {{ trackCodeDetail.jin }}гр</span>
        </div>
        <div>
            <span v-if="trackCodeDetail.urt">Ачааны урт: {{ trackCodeDetail.urt }}</span>
        </div>
        <div>
            <span v-if="trackCodeDetail.undur">Ачааны өндөр: {{ trackCodeDetail.undur }}</span>
        </div>
        <div>
            <span v-if="trackCodeDetail.urgun">Ачааны өргөн: {{ trackCodeDetail.urgun }}</span>
        </div>
        <div>
            <span v-if="trackCodeDetail.ezelhuun">Ачааны эзэлхүүн: {{ trackCodeDetail.ezelhuun }}</span>
        </div>
        <div>
            <span v-if="trackCodeDetail.taviur_code">Тавиурын код: {{ trackCodeDetail.taviur_code }}</span>
        </div>
        <el-card v-for="item,index in trackCodeDetail.Progress" :key="index" class="mt-2 br-20 br-20" shadow="always" :body-style="{ padding: '0px' }">
          <el-row class="p-5">
            <el-col>
              <el-tag v-if="item && item.progress_code">{{ returnStatusValue(item.progress_code) }}</el-tag>
            </el-col>
            <el-col>
              <p v-if="item && item.createdAt">Төлөвийн огноо: {{ item.createdAt.split('T')[0] }}</p>
            </el-col>
            <el-col>
              <p v-if="item.User && item.User.firstName">Үүсгэсэн хэрэглэгч: {{ item.User.firstName }}</p>
            </el-col>
            <el-col>
              <p v-if="item && item.start_date">Хадгалуулж эхлэх огноо: {{ item.start_date.split('T')[0] }}</p>
            </el-col>
            <el-col>
              <p v-if="item && item.end_date">Хадгалуулж дуусах огноо: {{ item.end_date.split('T')[0] }}</p>
            </el-col>
            <el-col>
              <p v-if="item && item.description">Хадгалуулж дуусах огноо: {{ item.description }}</p>
            </el-col>
            <el-col>
              <p v-if="item && item.ochij_avah_ognoo">Очиж авах огноо: {{ item.ochij_avah_ognoo.split('T')[0] }}</p>
            </el-col>
            <el-col>
              <p v-if="trackCodeDetail.Address && item.Address.detail_address">Хүргүүлэх хаяг: {{ item.Address.detail_address.split('T')[0] }}</p>
            </el-col>
            <el-col>
              <hr class="m-t-10 m-b-10">
              <div v-for="items,index in item.CheckTrackCode" :key="index" class="no_wrap font_size">Явц:
                <el-tag v-if="items.type && items.type === 'new'" size="mini">Үүсгэсэн</el-tag>
                <el-tag v-if="items.type && items.type === 'to_ereen'" size="mini" type="warning">Эрээн салбарт шилжүүлсэн</el-tag>
                <el-tag v-if="items.type && items.type === 'to_mongol'" size="mini" type="info">Монгол салбарт шилжүүлсэн</el-tag>
                <el-tag v-if="items.type && items.type === 'to_user'" size="mini" type="danger">Хэрэглэгч рүү шилжүүлсэн</el-tag>
                <el-tag v-if="items.type && items.type === 'from_user'" size="mini" type="type">Хэрэглэгч хариу ирүүлсэн</el-tag>
                <div v-if="items.createdAt">Үүсгэсэн огноо: <span class="check_tarck_img_text">{{ items.createdAt.split('T')[0] }}</span></div>
                <div v-if="items.description">Тайлбар: <span class="check_tarck_img_text">{{ items.description }}</span></div>
                <div v-if="items.hurgelt && items.hurgelt === true">Хүлээн авах хэлбэр: <span class="check_tarck_img_text">Хүргэлтээр авна</span></div>
                <div v-if="items.ochij_avah && items.ochij_avah === true">Хүлээн авах хэлбэр: <span class="check_tarck_img_text">Очиж авна</span></div>
                <div v-if="items.map_to_ereen && items.map_to_ereen === true">Газрын зураг дээр эрээнд очсон эсэх: <span class="check_tarck_img_text">Очсон</span></div>
                <div v-if="items.map_to_ereen && items.map_to_ereen === false">Газрын зураг дээр эрээнд очсон эсэх: <span class="check_tarck_img_text">Очоогүй</span></div>
                <div v-if="items.map_to_ereen_date">Газрын зураг дээр эрээнд очсон огноо: <span class="check_tarck_img_text">{{ items.map_to_ereen_date.split('T')[0] }}</span></div>
                <div v-if="items.map_to_ereen_aguulah && items.map_to_ereen_aguulah === true">Систем дээр эрээнд очсон эсэх: <span class="check_tarck_img_text">Очсон</span></div>
                <div v-if="items.map_to_ereen_aguulah && items.map_to_ereen_aguulah === false">Систем дээр эрээнд очсон эсэх: <span class="check_tarck_img_text">Очоогүй</span></div>
                <div v-if="items.fb_name">Facebook нэр: <span class="check_tarck_img_text">{{ items.fb_name }}</span></div>
                <div v-if="item.CheckedBranch && item.CheckedBranch.branch_name">Ачаа захиалсан салбар: <span class="check_tarck_img_text">{{ item.CheckedBranch.branch_name }}</span></div>
                <div v-for="itemImg, index in items.CheckImage" :key="index" class="m-t-10">
                  <el-image :src="'https://daagiigaadskycargo.s3.ap-southeast-1.amazonaws.com' + itemImg.img_path" :preview-src-list="['https://daagiigaadskycargo.s3.ap-southeast-1.amazonaws.com' + itemImg.img_path]" fit="fill" style="width: 100%; border-radius: 8px; margin-bottom: 10px; border: 1px black solid;" />
                  <hr class="m-t-5 m-b-15">
                </div>
              </div>
            </el-col>
          </el-row>
        </el-card>
        <el-row>
          <el-col :span="24" class="m-t-10">
            <el-button v-if="isShowButton()" class="w-100 m-l-20 m-b-10" type="primary" size="small" @click="openCheckTrackCodeDialog('change', 'to_ereen')">Эрээн салбар руу шилжүүлэх</el-button>
            <div class="m-t-10" v-if="isShowButton()">
              <el-button v-if="isShowButton()" class="w-100 m-l-20 m-b-10" type="warning" size="small" @click="openCheckTrackCodeDialog('change', 'to_user')">Хэрэглэгч рүү шилжүүлэх</el-button>
            </div>
            <div class="m-t-10" v-if="isShowButton()">
              <el-button v-if="checkPermissionsPage('view_cancel')" class="w-100 m-l-20 m-b-10" type="danger" size="small" @click="openCheckTrackCodeDialog('cancel', 'cancel')">Цуцлах</el-button>
            </div>
            <div class="m-t-10" v-if="isShowButton()">
              <el-button  v-if="checkPermissionsPage('view_to_mongol')" class="w-100 m-l-20 m-b-10" type="primary" size="small" @click="openCheckTrackCodeDialog('change', 'to_mongol')">Монгол салбар руу шилжүүлэх</el-button>
            </div>
          </el-col>
        </el-row>
      </el-dialog>
      <CheckTrackCodeDialog v-if="this.$root.checkTrackCodeDialog" :isChange="this.isChnage" :transactionTypeValue="this.transactionType" :progressId="this.progressId" @refreshData="getTrackCodeDetail"></CheckTrackCodeDialog>
    </div>
  </template>

<script>
import services from '@/helpers/services'
import CheckTrackCodeDialog from '@/views/Dialog/CheckTrackCodeDialog.vue'
import { checkPermissions } from '@/helpers/custom'

export default {
  data () {
    return {
      trackCodeDetail: {},
      isChnage: null,
      transactionType: null,
      progress_id: this.progressId
    }
  },
  props: {
    progressId: {
      type: Number,
      default: null
    },
    progressCodes: {
      type: Array
    }
  },
  components: {
    CheckTrackCodeDialog
  },
  //   computed: {
  //     ...mapGetters([
  //       'cdnGetter'
  //     ])
  //   },
  created () {
    this.getTrackCodeDetail()
    this.isShowButton()
  },
  methods: {
    async getTrackCodeDetail () {
      try {
        this.$root.fullscreenLoading = true
        const response = await services.getTrackCodeById(this.progressId)
        if (response) {
          this.trackCodeDetail = response.data
          this.$root.fullscreenLoading = false
        }
      } catch (error) {
        this.$notify({
          title: 'Амжилтгүй',
          message: 'Өгөгдөл татхад алдаа гарлаа. ' + error,
          type: 'error'
        })
        this.$root.fullscreenLoading = false
      }
    },
    handleClose () {
      this.$root.progressDetailDialog = false
    },
    returnStatusValue (data) {
      const result = this.$root.statusArray.find(element => element.value === data)
      if (result) {
        return result.label
      } else {
        return 'empty'
      }
    },
    openCheckTrackCodeDialog (change, type) {
      this.isChnage = change
      this.transactionType = type
      this.$root.checkTrackCodeDialog = true
    },
    isShowButton () {
      const progresses = this.trackCodeDetail.Progress
      if (!Array.isArray(progresses) || progresses.length === 0) return false

      // created_at-ийг огнооны талбараар нь солиорой!
      const sorted = progresses.slice().sort((a, b) => new Date(a.created_at) - new Date(b.created_at))
      const lastProgress = sorted[sorted.length - 1]

      return lastProgress?.progress_code === 180
    },
    checkPermissionsPage (data) {
      return checkPermissions(data)
    }
  }
}
</script>

<style>
</style>
